import ButtonLink from 'components/shared/ButtonLink.styled';
import { Heading1, Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { getPublicPath } from 'utils/paths';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';

export const StyledHero = styled.section`
  background-image: ${() =>
    `url('${getPublicPath('/images/resistance/resistance-bg.png')}')`};
  background-size: cover;
  background-position: top center;
  padding-bottom: 0;
  font-family: ${fontFamily('mono')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  display: flex;
  gap: ${spacing('xl')};
  padding-top: ${spacing('xl4')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};

  @media (max-width: ${screen('mdMax')}) {
    padding-top: ${spacing('xl')};
  }
`;

export const StyledContent = styled.div`
  flex-grow: 1;
  margin: auto;
  color: ${color('text_default_inverse')};
  font-size: ${fontSize('lg')};
  line-height: 1.6;
  padding-top: ${spacing('xl3')};

  @media (max-width: ${screen('mdMax')}) {
    font-size: ${fontSize('md')};
  }

  @media (min-width: ${screen('lg')}) {
    margin: 0;
    padding-top: ${spacing('xl8')};
  }

  ${Heading1} {
    text-align: center;
    font-family: 'OpenBrush', sans-serif;
    font-weight: normal;
    font-size: ${fontSize('xl6')};
    margin-bottom: ${spacing('xl4')};
    text-shadow: 2px 0 rgba(0, 0, 0, 0.25);

    @media (min-width: ${screen('lg')}) {
      font-size: ${fontSize('xl8')};
    }
  }

  ${Heading2} {
    text-align: center;
    margin-top: ${spacing('xl4')};
  }
`;

export const StyledIntro = styled.p`
  font-size: ${fontSize('lg')};
  text-align: center;
`;

export const StyledImage = styled.div`
  flex-shrink: 0;
  max-width: 18.5rem;
  margin: 0 auto;
`;

export const StyledCTA = styled.div`
  text-align: center;
  padding-top: ${spacing('xl4')};

  p {
    font-size: ${fontSize('sm')};
    text-transform: uppercase;
    font-weight: ${fontWeight('black')};
    font-family: ${fontFamily('sans')};
  }

  ${ButtonLink} {
    background-color: ${color('white')};
    border-color: ${color('white')};
    color: ${color('midnight_800')};
    font-size: ${fontSize('md')};

    svg {
      color: ${color('midnight_400')};
    }
  }
`;
